var map = {
	"./template.bet777": 1958,
	"./template.bet777.tsx": 1958,
	"./template.betgalaxy": 1959,
	"./template.betgalaxy.tsx": 1959,
	"./template.betprofessor": 1982,
	"./template.betprofessor.tsx": 1982,
	"./template.buffalobet": 1960,
	"./template.buffalobet.tsx": 1960,
	"./template.default": 142,
	"./template.default.tsx": 142,
	"./template.forsport": 1961,
	"./template.forsport.tsx": 1961,
	"./template.gigabet": 1962,
	"./template.gigabet.tsx": 1962,
	"./template.goldenbet888": 1963,
	"./template.goldenbet888.tsx": 1963,
	"./template.goldenrush": 1964,
	"./template.goldenrush.tsx": 1964,
	"./template.juicybet": 1965,
	"./template.juicybet.tsx": 1965,
	"./template.magnumbet": 1966,
	"./template.magnumbet.tsx": 1966,
	"./template.oldgill": 2053,
	"./template.oldgill.tsx": 2053,
	"./template.puntgenie": 1983,
	"./template.puntgenie.tsx": 1983,
	"./template.pyramidbet": 1967,
	"./template.pyramidbet.tsx": 1967,
	"./template.slambet": 1968,
	"./template.slambet.tsx": 1968,
	"./template.sterlingparker": 1969,
	"./template.sterlingparker.tsx": 1969,
	"./template.templebet": 1970,
	"./template.templebet.tsx": 1970,
	"./template.titanbet": 1971,
	"./template.titanbet.tsx": 1971,
	"./template.ts": 996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2808;